package gr.tech.GRAttestation.sections.store

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.infrastructure.session.StoreUserSession
import gr.tech.GRAttestation.navigation.SitePage
import gr.tech.GRAttestation.styles.store.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun StoreUserNavHeader(
    onLogout: () -> Unit
) {
    Nav(
        attrs = StoreNavbarStyle.toModifier().toAttrs {
            attr("role", "navigation")
            attr("aria-label", "main navigation")
        }
    ) {
        Div(
            attrs = StoreNavbarContainerStyle.toModifier().toAttrs()
        ) {
            // When not logged in: centered logo only
            if (!StoreUserSession.isLoggedIn()) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center
                ) {
                    Image(
                        src = "/gricon.png",
                        alt = "Green Rebates Logo",
                        modifier = StoreNavbarLogoStyle.toModifier()
                    )
                }
            }

            // When logged in: logo on left, store name + sign out on right
            if (StoreUserSession.isLoggedIn()) {
                // Left side - Logo
                Link(
                    path = SitePage.Dashboard.route
                ) {
                    Image(
                        src = "/gricon.png",
                        alt = "Green Rebates Logo",
                        modifier = StoreNavbarLogoStyle.toModifier()
                    )
                }

                // Right side - Store info and sign out
                Div(
                    attrs = StoreNavbarStoreInfoStyle.toModifier().toAttrs()
                ) {
                    SpanText(
                        text = StoreUserSession.getStoreName(),
                        modifier = StoreNavbarStoreNameStyle.toModifier()
                    )

                    Span(attrs = StoreNavbarButtonStyle.toModifier()
                        .toAttrs {
                            onClick { onLogout() }
                        }
                    ) {
                        Text("Sign Out")
                    }
                }
            }
        }
    }
}